export default __webpack_public_path__ + "static/media/no_image.bf93c1a5.png";